import { getCountry } from '@iwIntlProvider/CountryProvider';

import { FundingRequirementsDE } from './DE/FundingRequirementsDE';
import { FundingRequirementsUK } from './FundingRequirementsUK';

export const FundingRequirements = () => {
    if (getCountry() === 'DE') {
        return (
            <div data-testid="funding-requirements-de">
                <FundingRequirementsDE />
            </div>
        );
    }

    return (
        <div data-testid="funding-requirements-uk">
            <FundingRequirementsUK />
        </div>
    );
};
